import React from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { RouteComponentProps } from 'react-router';
import { IStore } from 'reducers/index';
import { fetchEquipmentChargesDetails, getEquipmentDetails, getEquipmentsHeader } from 'actions/equipments';
import { ErrorDialog } from 'components/error-dialog';
import API from 'constants/api';
import { PageHeader } from 'components/page-header';
import { TabComponent } from 'components/sub-navigation/components/TabComponent';
import { calculateTotalOfField, generateDistributionData, findAllinArr } from 'views/job-costing/utils/CostAndRevenueHelpers';
import { CostAndRevenue } from 'modules/cost-revenue/component/CostAndRevenue';
import { DetailsTopBar } from './DetailsTopBar';
import EqDetails from './EqDetails';
import {
    navLinksEquipment,
    voyagesCols,
    equipmentTransportShipmentsCols,
    cblCols,
    clrCols,
    bookingsCols,
    equipmentDocumentCols,
    customerInvoiceCols
}
    from 'constants/tableConstants'
import { withRouter } from 'react-router-dom';
import { clearFormat, isFeatureEnabled } from 'utilities/util';
import CostColumnsData from 'views/job-costing/utils/CostColumnsData';
import { HeaderWrapper } from 'components/cost-revenue/HeaderWrapper';
import InPageDialog from '../../../../components/page-dialog';
import { HistoryLog } from 'modules/history/HistoryLog';
import { IEquipmentDetail, IEquipmentDetailsCostAndRevenue, IEquipmentHeader } from 'reducers/equipments/models';
import { formatValueIfNullOrUndefined } from 'utilities/util';
import * as ValidationMessages from 'constants/validationMessages';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { localCurrency } from 'constants/customs';
import { fetchCostAndRevenue } from 'actions/costRevenue';
import { IResponse } from 'reducers/bookings/models';
import { targetFunctionality } from 'constants/targetFunctionality';
import { fetchNftpBillable } from 'actions/exportJob';
import { isNftpRoeEnabled, calculateActualTotal } from 'utilities/nftp';
interface IParams {
    equipmentId: string
}
interface IMapDispatchToProps {
    getEquipmentDetails: (equipmentId: number) => Promise<void>;
    getEquipmentsHeader: (equipmentId: number) => Promise<void>;
    fetchEquipmentChargesDetails: (equipmentId: number) => Promise<void>;
    fetchCostAndRevenue: (type: number, valueId: any[], targetType: string) => Promise<void>;
    fetchNftpBillable: (jobId: number) => Promise<void>;
}
interface IMapStateToProps {
    response: IEquipmentDetail;
    isFetchDataError: boolean;
    isAccessDenied?: boolean;
    isLoading: boolean;
    detailsPendingError: string;
    featureToggles: IFeatureToggleModel[];
    costAndrevenueresponse: IResponse;
    equipmentHeader: IEquipmentHeader;
    costAndRevenueSplits: IEquipmentDetailsCostAndRevenue[];
    isNftpBillable: boolean | undefined;
    isNftpBillableLoading: boolean;
}
interface IDocCharges extends RouteComponentProps<IParams>, IMapDispatchToProps, IMapStateToProps { }

interface IState {
    activeTab: number,
    disableTab: boolean,
    hasError: boolean,
    totalRevenue: string,
    totalCost: string,
    showDialog: boolean,
    pendingError: string,
    status: string[],
    isNftpRoeEnabled?: boolean;
    isNftpRoeEnabledLoading?: boolean;
    actualRevenue?: string;
    actualCost?: string;
}
export class _ChargesEquipmentsDetails extends React.Component<IDocCharges, IState> {
    constructor(props: IDocCharges) {
        super(props);
        this.state = this.initialState()
    }
    public componentDidMount() {
        this.props.getEquipmentsHeader(Number(this.props.match.params.equipmentId));
        this.props.getEquipmentDetails(Number(this.props.match.params.equipmentId));
        this.props.fetchEquipmentChargesDetails(Number(this.props.match.params.equipmentId));
        this.props.fetchCostAndRevenue(2, [Number(this.props.match.params.equipmentId)], 'origin');
    }
    
    public componentWillUnmount() {
        this.initialState()
    }
    public initialState = (): IState => {
        return {
            activeTab: 0,
            disableTab: false,
            showDialog: false,
            totalRevenue: '0',
            totalCost: '0',
            pendingError: '',
            status: [],
            hasError: false,
            isNftpRoeEnabled: false,
            isNftpRoeEnabledLoading: true,
            actualRevenue: '0',
            actualCost: '0'
        }
    }
    public async componentDidUpdate(props: any) {
        if (this.props.isFetchDataError !== this.props.isFetchDataError &&
            this.props.isFetchDataError === true && this.props.detailsPendingError) {
            let checkText: string | string[] = this.props.detailsPendingError
            if ((Array.isArray(this.props.detailsPendingError) &&
                this.props.detailsPendingError.length === 0) ||
                this.props.detailsPendingError === '') {
                checkText = 'Server Error. Try again later.'
            }
            this.setState({ showDialog: true, pendingError: checkText.toString() })
        }
        if (this.props.response !== props.response) {
            const firstJob = this.props.response.documents[0];
            if (firstJob && isFeatureEnabled(FEATURE_TOGGLES.FINOPS_NFTP_SALESORDER_REQ_EXPORT, this.props.featureToggles)) {
                await this.props.fetchNftpBillable(Number(firstJob.exportJobId));
            }
            this.setState({ isNftpRoeEnabled: isNftpRoeEnabled(this.props.isNftpBillable ?? false, this.props.featureToggles) });
            this.setState({ isNftpRoeEnabledLoading: false});
            this.getActualTotal();
            const handleError = (error: string[]): boolean => {
                const errList: string[] = []
                this.props.response.documents.forEach((child: any) => {
                    if (child.rateErrorMessage && child.rateErrorMessage !== '-') {
                        errList.push(child.rateErrorMessage)
                    }
                })
                if (error && errList && errList.length > 0) {
                    this.setState({ showDialog: true, pendingError: errList.toString().replace(/\|/g, '\n') })
                    return true
                }
                return false
            }

            const status: string[] = findAllinArr(this.props.response.documents, 'finOpsStatus')
            const hasError: boolean = this.props.response && this.props.response.documents ? handleError(this.props.response.documents) : false;
            this.setState({
                status,
                hasError
            })
        }
    }
    public getActualTotal = () => {
        const rateDetailsList = this.props.costAndrevenueresponse.result[0]?.essoRateDetailsModels || [];
        const actualRevenue = calculateActualTotal(rateDetailsList, CostColumnsData.TYPES.REVENUE);
        const actualCost = calculateActualTotal(rateDetailsList, CostColumnsData.TYPES.COST);
        this.setState({ actualRevenue, actualCost }) ;
    };
    public getCLRs() {
        const ids: string[] = [];
        if (this.props.response && this.props.response.clrs && this.props.response.clrs.length > 0) {
            this.props.response.clrs.forEach((clr: any) => ids.push(clr.clrNumber));
        }
        return ids && ids.length > 0 ? ids : '-'
    }
    public render() {
        // Red List (ISCMLP-149314): when the (red-list-filtered) details endpoint denies access it
        // returns 404, and getEquipmentDetails maps that to isAccessDenied. Block the entire page so
        // the header/top-bar/tabs (driven by the separate, unfiltered header call) are never shown.
        if (this.props.isAccessDenied) {
            return (
                <React.Fragment>
                    <PageHeader id="equipment-header" backButton={true}>Equipment Details</PageHeader>
                    <div className="padding-left-large padding-right-large padding-top-large">
                        <div className="message failed">
                            <i aria-hidden="true" className="fa fa-times-circle fa-2x padding-right-medium" />
                            <span>{ValidationMessages.Equipment.AccessDenied}</span>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
        const isExtraDocumentFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.EXTRA_DOCUMENT, this.props.featureToggles);
        const isWebApiEquipmentDetailsFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_WEBAPI_EQUIPMENT_DETAILS, this.props.featureToggles);
        let exportJobLinks;
        if (this.props.response.documents) {
            const filteredDocs = this.props.response.documents.filter(item => item.finNumber);
            exportJobLinks = filteredDocs.length > 0 ? filteredDocs.map((item, index) => <div className="mB10" key={index} ><a onClick={() => { this.props.history.push(`/job-costing/exportjobs/${item.exportJobId}`) }} >{item.finNumber}</a></div>) : '-';
        }
        else {
            exportJobLinks = '-';
        }
        return (
            <React.Fragment>
                <ErrorDialog endpoint={isWebApiEquipmentDetailsFeatureEnabled ? API.Equipment.EquipmentDetails : API.Equipment.GetEquipmentDetails} />
                <PageHeader
                    id="equipment-header"
                    displayConfirm={this.state.disableTab}
                    confirmMessage={this.state.disableTab ? ValidationMessages.CostAndRevenue.Alert_Page_Exit : ''}
                    backButton={true}>Equipment Number: {this.props.equipmentHeader.equipmentNumber}</PageHeader>
                {this.state.showDialog && <div className={'padding-bottom-large padding-left-large padding-right-large'}><InPageDialog
                    showDialog={this.state.showDialog}
                    type={'error'}
                    message={this.state.pendingError}
                    closeMethod={() => this.setState({ showDialog: false })} /></div>}
                <HeaderWrapper
                    firstValue={this.props.equipmentHeader.sealNumber1}
                    firstValueLabel={'Seal Number'}
                    secondValue={`${formatValueIfNullOrUndefined(this.props.equipmentHeader.size)}/${formatValueIfNullOrUndefined(this.props.equipmentHeader.type)}`}
                    secondValueLabel={'Size/Type'}
                    thirdValue={this.props.equipmentHeader.subType}
                    thirdValueLabel={'Sub Type'}
                    forthValue={this.props.equipmentHeader.opsStatus}
                    forthValueLabel={'Status'}
                    totals={{
                        firstRow: { label: 'Total Revenue', value: this.state.totalRevenue, actualValue: this.state.actualRevenue },
                        secondRow: { label: 'Total Cost', value: this.state.totalCost, actualValue: this.state.actualCost },
                        lastRow: { label: 'Profitability' },
                        isNftpRoeEnabled: this.state.isNftpRoeEnabled
                    }}
                />
                <DetailsTopBar
                    quantity={String(this.props.equipmentHeader.quantity)}
                    weight={clearFormat(String(this.props.equipmentHeader.weight), 3)}
                    shipmentType={`${this.props.equipmentHeader.shipmentTypeAtOrigin}/${this.props.equipmentHeader.shipmentTypeAtDestination}`}
                    volume={clearFormat(String(this.props.equipmentHeader.volume), 3)}
                    packages={String(this.props.equipmentHeader.totalPackages)}
                    sealNumber1={this.props.equipmentHeader.sealNumber1}
                    createdDate={this.props.equipmentHeader.createDate}
                    lastUpdated={this.props.equipmentHeader.updatedDate}
                />

                <div className="padding-left-large padding-right-large">

                    {this.props.equipmentHeader && this.props.costAndRevenueSplits &&
                        <TabComponent name="equipments" navLinks={navLinksEquipment}
                            isDisabled={this.state.disableTab}
                            callbackFc={(e: number) => this.setState({ activeTab: e })} >
                            {!this.props.isNftpBillableLoading && !this.state.isNftpRoeEnabledLoading && this.props.equipmentHeader.equipmentId && this.props.costAndrevenueresponse.result.length > 0 && <CostAndRevenue
                                targetType="origin"
                                showInvoices={false}
                                toggleTabs={(b: boolean) => this.setState({ disableTab: b })}
                                fStatus={this.state.status}
                                targetId={targetFunctionality.Equipment}
                                partyData={{ country: this.props.response.equipmentParty && this.props.response.equipmentParty.issuerCountryCode, company: this.props.response.equipmentParty && this.props.response.equipmentParty.companyCode, purchase: this.props.response.purchaseOrganisation }}
                                distributionData={generateDistributionData({ costAndRevenueSplits: this.props.costAndRevenueSplits })}
                                readOnly={true}
                                splitCols={CostColumnsData.getCostEqSubCols(isExtraDocumentFeatureEnabled)}
                                docId={this.props.equipmentHeader.equipmentId}
                                costAndRevenueId={this.props.equipmentHeader.equipmentId}
                                costAndrevenueresponse={this.props.costAndrevenueresponse}
                                eventCallback={() => this.setState({ showDialog: false, pendingError: '' })}
                                outputCostRev={(cost: any[], revenue: any[]) => {
                                    this.setState({ totalCost: clearFormat(calculateTotalOfField(cost, localCurrency.totalLocalCurrency)) });
                                    this.setState({ totalRevenue: clearFormat(calculateTotalOfField(revenue, localCurrency.totalLocalCurrency)) })
                                }
                                }
                                isNftpBillable = {this.props.isNftpBillable}
                                isNftpRoeEnabled = {this.state.isNftpRoeEnabled}
                                />}
                            <EqDetails
                                organisation={[
                                    { label: 'Company Code', value: this.props.response.equipmentParty && formatValueIfNullOrUndefined(this.props.response.equipmentParty.companyCode) },
                                    { label: 'Plant', value: this.props.response.equipmentParty && formatValueIfNullOrUndefined(this.props.response.plant) },
                                    { label: 'Place Area', value: this.props.response.equipmentParty && formatValueIfNullOrUndefined(this.props.response.equipmentParty.salesArea) },
                                    { label: 'Purchase Organisation', value: this.props.response.equipmentParty && formatValueIfNullOrUndefined(this.props.response.purchaseOrganisation) },
                                    { label: 'Origin Office', value: this.props.response.equipmentParty && formatValueIfNullOrUndefined(this.props.response.originOffice) },
                                    { label: 'Destination Office', value: this.props.response.equipmentParty && formatValueIfNullOrUndefined(this.props.response.destinationOffice) }
                                ]}
                                locations={[
                                    { label: 'Place of receipt code', value: this.props.response.equipmentParty && formatValueIfNullOrUndefined(this.props.response.equipmentParty.placeOfReceiptCode) },
                                    { label: 'Port of loading code', value: this.props.response.equipmentParty && formatValueIfNullOrUndefined(this.props.response.equipmentParty.portOfLoadingCode) },
                                    { label: 'Port of discharge code', value: this.props.response.equipmentParty && formatValueIfNullOrUndefined(this.props.response.equipmentParty.portOfDischargeCode) },
                                    { label: 'Place of delivery code', value: this.props.response.equipmentParty && formatValueIfNullOrUndefined(this.props.response.equipmentParty.placeOfDeliveryCode) },
                                    { label: 'Place of receipt name', value: this.props.response.equipmentParty && formatValueIfNullOrUndefined(this.props.response.equipmentParty.placeOfReceiptName) },
                                    { label: 'Port of loading name', value: this.props.response.equipmentParty && formatValueIfNullOrUndefined(this.props.response.equipmentParty.portOfLoadingName) },
                                    { label: 'Port of discharge name', value: this.props.response.equipmentParty && formatValueIfNullOrUndefined(this.props.response.equipmentParty.portOfDischargeName) },
                                    { label: 'Place of delivery name', value: this.props.response.equipmentParty && formatValueIfNullOrUndefined(this.props.response.equipmentParty.placeOfDeliveryName) },
                                    { label: 'Place of consolidation code', value: formatValueIfNullOrUndefined(this.props.response.placeOfConsolidationCode) },
                                    { label: 'Empty return location code', value: formatValueIfNullOrUndefined(this.props.response.emptyReturnLocationCode) },
                                    { label: 'Empty return location name', value: formatValueIfNullOrUndefined(this.props.response.emptyReturnLocationName) },

                                ]}
                                serviceType={[
                                    { label: 'Equipment Type at Origin', value: formatValueIfNullOrUndefined(this.props.response.shipmentTypeAtOrigin) },
                                    { label: 'Equipment Type at Destination', value: formatValueIfNullOrUndefined(this.props.response.shipmentTypeAtDestination) },
                                    { label: 'Origin Service', value: formatValueIfNullOrUndefined(this.props.response.serviceAtOrigin) },
                                    { label: 'Destination Service', value: formatValueIfNullOrUndefined(this.props.response.serviceAtDestination) },
                                    { label: 'Substitution Size', value: formatValueIfNullOrUndefined(this.props.response.substitutionSize) },
                                    { label: 'Substitution Type', value: formatValueIfNullOrUndefined(this.props.response.substitutionType) },
                                    { label: 'Delivery Movement Type', value: formatValueIfNullOrUndefined(this.props.response.deliveryMovementType) },
                                    { label: 'Pick Up Movement Type', value: formatValueIfNullOrUndefined(this.props.response.pickUpMovementType) }
                                ]}
                                jobIdDetails={[
                                    { label: 'Export', value: exportJobLinks },
                                    { label: 'Import', value: formatValueIfNullOrUndefined('') }
                                ]}
                                link={(url: string) => { this.props.history.push(url) }}
                                bookings={{ data: this.props.response.bookings, cols: bookingsCols, name: 'equipments-bookings-' }}
                                cbl={{ data: this.props.response.cbls, cols: cblCols, name: 'equipments-cbls-' }}
                                clr={{ data: this.props.response.clrs, cols: clrCols, name: 'equipments-clrs-' }}
                                fcr={{ data: this.props.response.documents, cols: equipmentDocumentCols, name: 'equipments-documents-' }}
                                equipmentTransportShipments={{ data: this.props.response.equipmentTransportShipments, cols: equipmentTransportShipmentsCols, name: 'equipments-equipmentTransportShipments-' }}
                                voyages={{ data: this.props.response.voyages, cols: voyagesCols, name: 'equipments-voyages-' }}
                                customerInvoice={{ data: this.props.response.billingDocuments, cols: customerInvoiceCols, name: 'equipments-customerInvoice-' }}
                                isExtraDocumentFeatureEnabled={isExtraDocumentFeatureEnabled}
                            />
                            {this.props.equipmentHeader.equipmentId && this.state.activeTab === 3 && <HistoryLog shipmentId={String(this.props.equipmentHeader.equipmentId)} shipmentType={2} />}
                        </TabComponent>}
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    response: state.equipments.response,
    isLoading: state.equipments.isFetchDataLoading,
    isFetchDataError: state.equipments.isFetchDataError,
    isAccessDenied: state.equipments.isAccessDenied,
    detailsPendingError: state.equipments.detailsPendingError,
    equipmentHeader: state.equipments.equipmentHeader,
    featureToggles: state.featureToggle.featureToggles,
    costAndrevenueresponse: state.costRevenue.response,
    costAndRevenueSplits: state.equipments.equipmentCostAndRevenueSplits,
    isNftpBillable: state.exportJob.nftpBillableResponse?.isNftpBillable,
    isNftpBillableLoading: state.exportJob.isNftpBillableLoading
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    getEquipmentDetails: (equipmentId: number) => dispatch(getEquipmentDetails(equipmentId)),
    getEquipmentsHeader: (equipmentId: number) => dispatch(getEquipmentsHeader(equipmentId)),
    fetchEquipmentChargesDetails: (equipmentId: number) => dispatch(fetchEquipmentChargesDetails(equipmentId)),
    fetchCostAndRevenue: (type: number, valueId: any, targetType: string) => dispatch(fetchCostAndRevenue(type, valueId, targetType)),
    fetchNftpBillable: (jobId: number) => dispatch(fetchNftpBillable(jobId))
});

export const _Equipments = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_ChargesEquipmentsDetails);
export const Equipments = withRouter(_Equipments);